function scale(x, domain, range) {
    let normX = (x - domain[0]) / (domain[1] - domain[0]);
    return range[0] + normX * (range[1] - range[0]);
}        
function clamp(x, range) {
    let lowerBound = Math.min(range[0], range[1]);
    let upperBound = Math.max(range[0], range[1]);
    return Math.min(Math.max(lowerBound, x), upperBound)
}
 
export {scale, clamp};



// WEBPACK FOOTER //
// ./src/functional.js